import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { getPathVariables } from '../../../misc';
import {
  fieldSubscriberDetailsContractTerm,
  contractTerm3Year,
  fieldSubscriberDetailsDevicePlan
} from '../../../utils/constant';
import { getFieldValue } from '../../utils';

import {
  DueMonthlyWrapper,
  DueNowWrapper,
  LabelDueMonthly,
  BeforeTaxesLabel,
  PricingBlockMain,
  IntegralPart,
  TimesMonth
} from '../css';

const TwoYear = ({ total, formFields }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: {
      DUE_MONTHLY,
      dueAtTimeOfPurchase,
      BEFORE_TAXES,
      ratePlanCost,
      easyPaymentCost,
      deviceUpfrontCost,
      deviceSalesTax
    },
    contentfulValues: {
      wirelessOrderDetails: {
        valueTwoYear,
        valueDevicePurchaseMtm,
        valueMobileHighSpeedSmartHub
      }
    }
  } = localizedStrings;
  const valueSubscriberDetailsContractTerm = getFieldValue(
    fieldSubscriberDetailsContractTerm,
    formFields
  );
  const valueDevicePlan = getFieldValue(
    fieldSubscriberDetailsDevicePlan,
    formFields
  );
  const isDevicesOnly =
    formFields.subscriberDetailsExistingPhoneNumber &&
    formFields.subscriberDetailsExistingPhoneNumber.isVisible;
  let monthsForPayments;
  if (
    valueTwoYear === valueSubscriberDetailsContractTerm ||
    isDevicesOnly ||
    (valueSubscriberDetailsContractTerm === valueDevicePurchaseMtm &&
      valueDevicePlan === valueMobileHighSpeedSmartHub)
  )
    monthsForPayments = `x 24 Months`;
  else if (
    contractTerm3Year[0] === valueSubscriberDetailsContractTerm ||
    contractTerm3Year[1] === valueSubscriberDetailsContractTerm
  )
    monthsForPayments = `x 36 Months`;
  else monthsForPayments = `x 12 Months`;

  const getFormattedPricing = price => {
    const locale = getPathVariables(window.location.pathname)[0];
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    const updatedprice = formatter.format(price);
    return <IntegralPart>{updatedprice}</IntegralPart>;
  };

  return (
    <>
      <DueMonthlyWrapper>
        <div>
          <LabelDueMonthly style={{ textAlign: 'center' }}>
            {DUE_MONTHLY}
          </LabelDueMonthly>
          <div style={{ display: 'flex', marginTop: '1rem' }}>
            <div
              style={{ padding: '0 1.5rem', borderRight: '1px solid #acacac' }}
            >
              <LabelDueMonthly>{ratePlanCost}</LabelDueMonthly>
              <PricingBlockMain>
                {getFormattedPricing(_.get(total, 'rateplanTotal', 0))}
                <TimesMonth>{monthsForPayments}</TimesMonth>
              </PricingBlockMain>

              <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
            </div>
            <div style={{ padding: '0 1.5rem' }}>
              <LabelDueMonthly>{easyPaymentCost}</LabelDueMonthly>
              <PricingBlockMain>
                {getFormattedPricing(_.get(total, 'easyPaymentTotal', 0))}
                <TimesMonth>{monthsForPayments}</TimesMonth>
              </PricingBlockMain>
              <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
            </div>
          </div>
        </div>
      </DueMonthlyWrapper>
      <DueNowWrapper>
        <div>
          <LabelDueMonthly style={{ textAlign: 'center' }}>
            {dueAtTimeOfPurchase}
          </LabelDueMonthly>
          <div style={{ display: 'flex', marginTop: '1rem' }}>
            <div
              style={{ padding: '0 1.5rem', borderRight: '1px solid #acacac' }}
            >
              <LabelDueMonthly>{deviceUpfrontCost}</LabelDueMonthly>
              <PricingBlockMain>
                {getFormattedPricing(_.get(total, 'deviceUpfrontTotal', 0))}
              </PricingBlockMain>
              <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
            </div>
            <div style={{ padding: '0 1.5rem' }}>
              <LabelDueMonthly>{deviceSalesTax}</LabelDueMonthly>
              <PricingBlockMain>
                {getFormattedPricing(_.get(total, 'deviceSalesTax', 0))}
              </PricingBlockMain>
            </div>
          </div>
        </div>
      </DueNowWrapper>
    </>
  );
};

TwoYear.propTypes = {
  total: PropTypes.objectOf(PropTypes.any).isRequired,
  formFields: PropTypes.objectOf(PropTypes.any).isRequired
};

export default TwoYear;
